import { useQuery } from '@tanstack/react-query';
import { getActiveTour } from '@/services/tour';

export default function useActiveTour(enabled: boolean) {
  return useQuery({
    queryKey: ['active-tour'],
    queryFn: () => getActiveTour(),
    enabled,
  });
}
